export const filterPendingByRegisterScope = (
  purchases,
  { cashRegisterSessionId, registerlessProfileId } = {}
) => {
  const list = Array.isArray(purchases) ? purchases : [];
  const hasSession =
    cashRegisterSessionId !== null
    && cashRegisterSessionId !== undefined
    && cashRegisterSessionId !== '';
  const hasRegisterlessProfile =
    registerlessProfileId !== null
    && registerlessProfileId !== undefined
    && registerlessProfileId !== '';
  if (hasSession) {
    const sessionKey = String(cashRegisterSessionId);
    return list.filter(
      (purchase) =>
        (
          purchase?.saleStatus === 'open'
          && String(purchase?.cashRegisterSessionId ?? '') === sessionKey
        )
        || (
          purchase?.saleStatus === 'suspended'
          && purchase?.registerlessProfileId != null
        )
    );
  }
  if (hasRegisterlessProfile) {
    const profileKey = String(registerlessProfileId);
    return list.filter(
      (purchase) =>
        purchase?.saleStatus === 'suspended'
        && String(purchase?.registerlessProfileId ?? '') === profileKey
    );
  }
  return [];
};

export const filterVisiblePendingPurchases = (purchases) => (
  (Array.isArray(purchases) ? purchases : []).filter((purchase) => {
    if (!purchase || purchase.isDeleted) return false;
    if (purchase.saleStatus !== 'open' && purchase.saleStatus !== 'suspended') return false;

    const purchaseItems = Array.isArray(purchase.PurchaseItems)
      ? purchase.PurchaseItems
      : (Array.isArray(purchase.purchaseItems) ? purchase.purchaseItems : []);
    const hasItems = purchaseItems.length > 0;
    const totalAmount = Number(purchase.totalAmount);
    const hasPositiveTotal = Number.isFinite(totalAmount) && totalAmount > 0;
    const hasClient = purchase.clientId != null || purchase.Client?.id != null;
    const isClientOnlyDraft = purchase.saleStatus === 'open' && hasClient;

    return hasItems || hasPositiveTotal || isClientOnlyDraft;
  })
);

export const applyActivePendingPurchaseLiveState = (
  purchases,
  {
    purchaseId,
    totalAmount,
    clientId,
    clientName,
  } = {}
) => {
  const activeId = purchaseId == null ? null : String(purchaseId);
  const parsedTotal = Number(totalAmount);
  const hasLiveTotal = totalAmount !== null
    && totalAmount !== undefined
    && totalAmount !== ''
    && Number.isFinite(parsedTotal);
  const normalizedClientName = typeof clientName === 'string' ? clientName.trim() : '';
  const hasLiveClientClear = clientId === null
    && typeof clientName === 'string'
    && normalizedClientName.length === 0;
  const hasLiveClient = clientId != null && normalizedClientName.length > 0;

  return (Array.isArray(purchases) ? purchases : []).map((purchase) => {
    if (activeId === null || String(purchase?.id) !== activeId) return purchase;

    return {
      ...purchase,
      ...(hasLiveTotal ? { totalAmount: parsedTotal } : {}),
      ...(hasLiveClient
        ? {
            clientId,
            Client: {
              ...(purchase?.Client || {}),
              id: clientId,
              name: normalizedClientName,
            },
          }
        : hasLiveClientClear
          ? { clientId: null, Client: null }
        : {}),
    };
  });
};
